 <template>
  <div class="login-wrapper">
    <header>
      <div class="main">
        <div class="top">
          <div class="logo bg"></div>
          <div class="title">上了智筑通 生意就轻松</div>
        </div>
      </div>
    </header>
    <div class="banner bg">
      <div class="form-box">
        <div class="qrcode">
          <div class="tips">
            <span> 扫码登录在这里 </span>
            <img src="./imgs/bubble.png" alt="" />
          </div>
          <img
            v-if="isAccountLogin"
            src="./imgs/qrcode.png"
            alt=""
            @click="isAccountLogin = false"
          />
          <img
            v-else
            src="./imgs/computed.png"
            alt=""
            @click="isAccountLogin = true"
          />
        </div>
        <div v-if="isAccountLogin" class="account-login">
          <div class="tab-list">
            <div @click="tabIndex = 0" class="tab-title active">账号登录</div>
            <div @click="tabIndex = 1" class="tab-title ml50">验证码登录</div>
          </div>
          <div class="tab-content">
            <div v-if="tabIndex === 0" class="account-login mt41">
              账号登录内容
            </div>
            <div v-else class="identity-login mt41">验证码登录</div>
          </div>
        </div>
        <div v-else class="qrcode-login">
          <div class="tab-list">
            <div class="tab-title active">手机扫码登录</div>
          </div>
          <div class="tab-content">
            <div class="qrcode-img"></div>
            <p>微信扫一扫直接登录</p>
            <p>未注册请，<a href="#">免费注册</a></p>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <div class="main">
        <div class="friendship-link">
          友情链接：
          <a href="http://www.gov.cn/" target="_blank">中国政府网</a> |
          <a href="http://www.ganggouyc.com/" target="_blank">钢构英才网</a> |
          <a href="https://www.mysteel.com/" target="_blank">我的钢铁网</a> |
          <a href="http://www.zhaogang.com/" target="_blank">找钢网</a> |
          <a href="http://www.cscscn.cn/" target="_blank">钢构产业网</a> |
          <a href="http://www.xdjzcyw.com/" target="_blank">现代建筑产业网</a> |
          <a href="http://www.crcc.cn/" target="_blank">中国铁建</a> |
          <a href="https://www.cscec.com.cn/" target="_blank">中建集团</a> |
          <a href="https://www.ccccltd.cn/" target="_blank">中国交建</a> |
          <a href="https://www.scg.com.cn/" target="_blank">上海建工</a>
        </div>
        <div class="copyright">
          &copy; Copyright 2019-2020&nbsp; 上海西兰蒂亚科技有限公司&nbsp;
          版权所有 沪ICP备19042151号-3&nbsp;
        </div>
        <div class="beian">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502016251"
            style="
              display: inline-block;
              text-decoration: none;
              height: 20px;
              line-height: 20px;
            "
          >
            <img
              src="../../assets/images/homePage/guohui.png"
              style="float: left"
            />
            <p
              style="
                float: left;
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
              "
            >
              沪公网安备 31011502016251号
            </p>
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

 <script>
export default {
  name: 'Login',
  data() {
    return {
      isAccountLogin: true,
      tabIndex: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.login-wrapper {
  width: 100%;
  background: #ffffff;
  .main {
    width: 1200px;
    margin: 0 auto;
    .top {
      height: 124px;
      display: flex;
      align-items: center;
    }
    .logo {
      width: 190px;
      height: 64px;
      background-image: url('../../assets/images/logo.png');
    }
    .title {
      height: 42px;
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 64px;
      margin-left: 29px;
    }
  }
  .bg {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .banner {
    width: 100%;
    height: 700px;
    background-image: url('./imgs/banner.png');
    position: relative;
    .form-box {
      width: 390px;
      height: 500px;
      background: #ffffff;
      border-radius: 4px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(30%, -50%);
      .qrcode {
        padding: 15px 15px 0 0;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        .tips {
          width: 107px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          margin-right: 1px;
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #e0717c;
          position: relative;
          img {
            width: 100%;
            height: auto;
          }
          span {
            position: absolute;
            left: 8px;
            top: 0;
            line-height: 26px;
          }
        }
        img {
          width: 52px;
          height: auto;
          cursor: pointer;
          cursor: pointer;
        }
      }
      .tab-list {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        .tab-title {
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 28px;
          cursor: pointer;
        }
        .active {
          color: #ce2939;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: -6px;
            transform: translateX(-50%);
            width: 28px;
            height: 2px;
            background: #ce2939;
            border-radius: 2px;
          }
        }
      }

      .tab-content {
        .qrcode-img {
          width: 140px;
          height: 140px;
          margin: 30px auto 0;
          border: 1px solid red;
        }
      }
    }
  }

  .ml50 {
    margin-left: 50px;
  }

  .mt41 {
    margin-top: 41px;
  }

  footer {
    height: 206px;
    overflow: hidden;
    .friendship-link {
      margin-top: 54px;
      line-height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333333;
      a {
        color: #333333;
        margin: 0 5px;
      }
      a:hover {
        text-decoration: underline;
        text-underline-offset: 2px;
      }
    }

    .copyright {
      width: 100%;
      font-size: 12px;
      text-align: center;
      color: #333333;
      margin-top: 12px;
    }

    .beian {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 300px;
      margin: 12px auto 0;
      a {
        color: #333333;
        img {
          width: auto;
          height: auto;
        }
      }
    }
  }
}
</style>
